module.exports = __webpack_public_path__ + "img/PL10018.cea66873.png";